import { Component, inject, input, OnInit } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SetInitialPasswordRestService } from '../../../_generated';

@Component({
    template: '',
})
export class SetInitialPasswordComponent implements OnInit {
    private setInitialPasswordService = inject(SetInitialPasswordRestService);

    // inputs directly get their values from URL query params ;)
    email = input<string>('');
    language = input<string>('de');

    async ngOnInit() {
        // get redirect URI from backend, email is mandatory
        if (this.email()) {
            const result = await lastValueFrom(this.setInitialPasswordService.setInitialPasswordControllerSetInitialPassword(this.email(), this.language()));
            window.location.href = result.setInitialPasswordUrl;
        } else {
            console.error('Setting initial password failed: email not given');
        }
    }
}
